import * as React from 'react';
import {FormGroup as MuiFormGroup, Stack} from '@mui/material';

const FieldCollection = (props: any) => {  
  return (
    <Stack alignItems="flex-start" spacing={1} direction="column" {...props} />
    // <div className="fieldCollection" {...props}/>
  );
}
export default FieldCollection;